// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-16580adc]{--dark-gray:#888;--ai-btn-color:#e8e8e8}.GenerateAIAnswerBtn[data-v-16580adc]{gap:4px;width:-webkit-max-content;width:-moz-max-content;width:max-content;background:var(--ai-btn-color)!important}.GenerateAIAnswerBtn .Text-Primary[data-v-16580adc]{color:#000;font-weight:500;line-height:1}.GenerateAIAnswerBtn .Text-Secondary[data-v-16580adc]{color:var(--dark-gray);line-height:1}", ""]);
// Exports
module.exports = exports;
